<template>
  <input
    type="checkbox"
    class="sliding-switch"
    :checked="modelValue"
    @change="updateValue"
  />
</template>

<script>
export default {
  name: 'SlidingSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false, // false = photo, true = video
    },
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.checked);
    },
  },
};
</script>

<style scoped>
.sliding-switch {
  appearance: none;
  width: 70px; /* ✅ bigger overall */
  height: 36px; /* ✅ bigger overall */
  border-radius: 18px;
  background-color: gray; /* neutral track */
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

/* The knob */
.sliding-switch::before {
  content: '📷'; /* photo icon by default */
  position: absolute;
  left: 2px;
  top: 50%;
  transform: translateY(-50%);
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: #2c3e50; /* blue knob */
  display: flex;
  align-items: top;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
}

/* Checked state = video */
.sliding-switch:checked::before {
  left: calc(100% - 34px); /* move knob to right */
  background-color: #ef4444; /* red knob */
  content: '🎬'; /* video icon */
  align-items: center;
}
</style>
